module.exports = __webpack_public_path__ + "img/way_image_02.65ee73a.svg";